import { cx } from "@emotion/css";
import type * as React from "react";
import { dataTableToolsRow } from "./LegacyDataTableStyles";
interface LegacyDataTableToolsRowProps {
    className?: string;
    children?: React.ReactNode;
}
export function LegacyDataTableToolsRow({ className, children }: LegacyDataTableToolsRowProps): React.ReactElement {
    return <tr className={cx(dataTableToolsRow, className)}>{children}</tr>;
}
